import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash.get';
import Link from '../../Link';

const AuthorCard = ({ author }) => {
  const defaultAuthorPhotoUrl = 'https://media1.s-nbcnews.com/i/newscms/2020_33/3403770/fallback_author_image-centered_2c5d5b248b0cc9c6b1ee438ca438f9ec.png';
  const id = get(author, 'id', '');
  const displayName = get(author, ['name', 'display'], '');
  const firstName = get(author, ['name', 'first'], '');
  const lastName = get(author, ['name', 'last'], '');
  const middleName = get(author, ['name', 'middle'], '');
  const title = get(author, ['name', 'title'], '');
  const suffix = get(author, ['name', 'suffix'], '');
  const pageUrl = get(author, ['url', 'primary'], '');
  const picUrl = get(author, ['primaryImage', 'url', 'primary'], '');
  const shortBio = get(author, 'shortBio', '');

  return (
    <Link
      to={pageUrl}
      className="author-card__link-wrapper"
      data-test="author-card__link-wrapper"
    >
      <article
        className="author-card"
        data-test="author-card"
        data-contentid={id}
      >
        <img
          src={picUrl.length ? picUrl : defaultAuthorPhotoUrl}
          alt={displayName}
          className={classNames('author-card__pic', { 'author-card__pic--missing': !picUrl })}
          data-test="author-card__pic"
        />
        <div
          className="author-card__text-group"
          data-test="author-card__text-group"
        >
          <div
            className="author-card__name"
            data-test="author-card__name"
          >
            <span
              className="author-card__first-name"
              data-test="author-card__first-name"
            >
              {
                title ? `${title} ${firstName} ${middleName}` : `${firstName} ${middleName}`
              }
            </span>
            <span
              className="author-card__last-name"
              data-test="author-card__last-name"
            >
              {
                suffix ? `${lastName} ${suffix}` : lastName
              }
            </span>
          </div>
          <div
            className="author-card__short-bio"
            data-test="author-card__short-bio"
          >
            {shortBio}
          </div>
        </div>
      </article>
    </Link>
  );
};

AuthorCard.contextTypes = {
  vertical: PropTypes.string,
};

AuthorCard.propTypes = {
  author: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.shape({
      display: PropTypes.string.isRequired,
      title: PropTypes.string,
      first: PropTypes.string.isRequired,
      middle: PropTypes.string,
      last: PropTypes.string.isRequired,
      suffix: PropTypes.string,
    }),
    pageUrl: PropTypes.string,
    picUrl: PropTypes.string,
    shortBio: PropTypes.string,
  }).isRequired,
};

export { AuthorCard };
